import { Injectable } from '@angular/core';
import * as L from 'leaflet';
import { AggregationPopStatusDto } from '../data/models/aggregation-pop-status-dto';
import { LinesPopDto } from '../data/models/lines-pop-dto';
import { PopStatus } from '../data/enums/pop-status';
import { MapService } from './map.service';
import { MarkerPopupService } from './marker-popup.service';


@Injectable({
  providedIn: 'root'
})
export class MarkerCreationService {
  lines: LinesPopDto[] = [];
  popup: L.popup = L.popup();

  constructor(private popupService: MarkerPopupService, private mapService: MapService) { }

  async createMarkerSign(pop: AggregationPopStatusDto) {
    let lat = pop.latitude;
    let long = pop.longitude;

    let upIcon = L.icon({
      iconUrl: '/assets/green.png',
      iconSize: [40, 30]
    });
    let maintenanceIcon = L.icon({
      iconUrl: '/assets/orange.png',
      iconSize: [40, 30]
    });
    let downIcon = L.icon({
      iconUrl: '/assets/red.png',
      iconSize: [40, 30]
    });
    let parentDownIcon = L.icon({
      iconUrl: '/assets/marker-icon.png',
      iconSize: [40, 30]
    })
    let unknownIcon = L.icon({
      iconUrl: '/assets/graymarker.png',
      iconSize: [40, 30]
    });
    let upsDowns = L.icon({
      iconUrl: '/assets/UpsAndDowns.png',
      iconSize: [40, 30]
    })
    let marker = L.marker([lat, long]);
    //check status rhe select the icon

    (pop.popStatus == (Number)(PopStatus.UpsDowns)) ? marker.setIcon(upsDowns) :
      (pop.popStatus == (Number) (PopStatus.Down)) ? marker.setIcon(downIcon) :
        (pop.popStatus == (Number)(PopStatus.Up)) ?
      marker.setIcon(upIcon)  : (pop.popStatus == (Number)(PopStatus.Maintenance)) ? marker.setIcon(maintenanceIcon) : marker.setIcon(unknownIcon);

    marker.bindTooltip((pop.popName !== null && pop.popName !== undefined && pop.popName !== "NULL" ? pop.popName : pop.popConvention) + ": ( " + pop.lineSummition + " ) lines");
    marker.bindPopup('', {  maxHeight: 175, maxWidth: 400, closeButton: false, scrollbars: true }).on("popupopen", (e) => {
      this.getContent(marker, pop);
    });
    
    marker.getPopup().on('remove', function (event) {
      return false;
    });
    /* marker.on('click',this.openPopupContent)*/
    marker.getPopup().update();
    return marker;
  }





  getContent(marker = L.marker, pop: AggregationPopStatusDto) {
      this.mapService.getAllLinesOfThisPop(pop.popConvention).subscribe((res: LinesPopDto[]) => {
        this.lines = res;
        let content = this.popupService.makePopup(this.lines);
        this.updatePopup(marker, content);
      });
  }
  updatePopup(marker: L.marker,content: string) {
    marker.getPopup().setContent(content);
    marker.getPopup().update();
  }
  
}
